// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Pagination {\n  display: flex;\n  justify-content: flex-end;\n}\n.page-box {\n  margin-top: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
